import { render, staticRenderFns } from "./PartnerCard.vue?vue&type=template&id=6e6ce72b&scoped=true&"
import script from "./PartnerCard.vue?vue&type=script&lang=js&"
export * from "./PartnerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6ce72b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VMenu})
